import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12.216 3.87a.25.25 0 0 0-.432 0L2.518 19.876a.25.25 0 0 0 .217.375h18.53a.25.25 0 0 0 .217-.375L12.217 3.87Zm-1.73-.751c.674-1.164 2.355-1.164 3.029 0l9.265 16.004c.676 1.167-.166 2.627-1.514 2.627H2.735c-1.349 0-2.19-1.46-1.515-2.627L10.486 3.12Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-1.005 7A.998.998 0 0 0 11 17c0 .552.445 1 .995 1h.01c.55 0 .995-.448.995-1s-.445-1-.995-1h-.01Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorAlert;
